import {useEffect, useRef, useState, useCallback} from 'react'

const OPTIONS = {
  fields: [
    'name',
    'geometry',
    'place_id',
    'address_component',
    'formatted_address', 
    'adr_address',
  ]
}



export function usePlaces(input) {
  
  const autocompleteRef = useRef()

  const [state, setState] = useState({place: false, text: ''})


  const handlePlaceChanged = useCallback(() => {
    if (!autocompleteRef.current) return
    const place = autocompleteRef.current.getPlace()
    const text  = place.name + ', ' + place.formatted_address

    setState({place, text})
  }, [autocompleteRef])


  useEffect(() => {
    if (!input || autocompleteRef.current) return

    let listener
    (async () => {
      // this returns { Autocomplete } in v4
      const { Autocomplete } = await window.google.maps.importLibrary('places')
      autocompleteRef.current = new Autocomplete(input, OPTIONS)
      listener = autocompleteRef.current.addListener('place_changed', handlePlaceChanged);
    })()

    return () => {
      if (listener) listener.remove()
      // Clean up any stray dropdown containers
      document.querySelectorAll('.pac-container').forEach(el => el.remove())
    }
  }, [input, handlePlaceChanged])


  return [state.place, state.text]
}


export default usePlaces